var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.003,
    height: 36.001,
    viewBox: "0 0 36.003 36.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment_done",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2158",
    "data-name": "Group 2158",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2157",
    "data-name": "Group 2157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8587",
    "data-name": "Path 8587",
    d: "M33.7,29.455H27.944a6.545,6.545,0,0,1,0-13.091H33.7a.82.82,0,0,0,.822-.818V13.091A3.272,3.272,0,0,0,31.5,9.845l-4.72-8.207a3.26,3.26,0,0,0-4.462-1.2L6.132,9.819H3.29A3.283,3.283,0,0,0,0,13.091V32.728A3.283,3.283,0,0,0,3.29,36H31.231a3.283,3.283,0,0,0,3.287-3.273V30.273a.82.82,0,0,0-.818-.818ZM27.792,6.7l1.791,3.114H22.42ZM9.4,9.819,23.14,1.855a1.611,1.611,0,0,1,2.208.6h0l-12.7,7.364Z",
    transform: "translate(-0.003)",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8588",
    "data-name": "Path 8588",
    d: "M308.32,234.674h-5.2a4.454,4.454,0,1,0,0,8.908h5.2a2.229,2.229,0,0,0,2.227-2.227V236.9a2.229,2.229,0,0,0-2.227-2.226Zm-5.2,5.939a1.485,1.485,0,1,1,1.485-1.485,1.485,1.485,0,0,1-1.485,1.485Z",
    transform: "translate(-274.547 -216.048)",
    fill: "#585858"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDone);
export default __webpack_public_path__ + "static/media/payment_done.178b82409da7b1305f32b28c55eddf42.svg";
export { ForwardRef as ReactComponent };